module.exports = __webpack_public_path__ + "static/media/supply_image_2.c6f16709.jpg";